export default "__VITE_ASSET__DrzhThaR__"